import { ArrowRight } from "lucide-react";
import { goToWaitlist } from "@/lib/site";
import { Reveal } from "./Reveal";
import { WordmarkLockup } from "./Wordmark";

export const Hero = () => (
  <section id="home" data-testid="section-home" className="relative overflow-hidden pt-[calc(var(--cl-bar-h,0px)+2.5rem)] transition-[padding-top] duration-500 ease-out sm:pt-[calc(var(--cl-bar-h,0px)+1rem)]">
    <div className="pointer-events-none absolute left-1/2 top-[38%] h-[520px] w-[900px] max-w-[180vw] -translate-x-1/2 -translate-y-1/2 bg-[radial-gradient(ellipse_at_center,rgba(121,185,255,0.10)_0%,transparent_65%)]" />
    <div className="relative mx-auto h-[440px] w-full overflow-hidden sm:aspect-[1264/848] sm:h-auto sm:w-[min(100%,128svh)]">
      <div
        data-testid="hero-image-frame"
        className="absolute inset-y-0 left-1/2 aspect-[1264/848] -translate-x-[52%] sm:inset-x-0 sm:w-full sm:translate-x-0"
      >
        <img
          src="/assets/hero_loop_v2.jpg"
          alt="A glowing ribbon of family photographs forming an infinity loop above the earth's horizon"
          data-testid="hero-image"
          className="hero-img absolute inset-0 h-full w-full"
          fetchPriority="high"
        />
        <div className="hero-feather pointer-events-none absolute inset-0" />
        <div className="absolute left-[52%] top-[44%] z-10 w-max -translate-x-1/2 -translate-y-1/2 text-center">
          <WordmarkLockup
            testid="hero-overlay-wordmark"
            className="text-[1.15rem] sm:text-[1.55rem] md:text-[1.7rem] lg:text-[2.2rem] xl:text-[2.6rem]"
            taglineClass="text-[8px] sm:text-[10px] lg:text-[11px]"
          />
        </div>
      </div>
      <div className="pointer-events-none absolute inset-0 bg-[linear-gradient(to_right,#030507_0%,rgba(3,5,7,0)_12%,rgba(3,5,7,0)_88%,#030507_100%)] sm:hidden" />
    </div>

    <div className="cl-container relative -mt-14 pb-16 text-center sm:-mt-24 md:pb-20">
      <Reveal>
        <p data-testid="hero-eyebrow" className="cl-kicker">YOUR FAMILY. FOREVER.</p>
      </Reveal>
      <Reveal delay={120}>
        <h1 data-testid="hero-headline" className="cl-heading mt-6 text-[2.05rem] leading-[1.1] sm:text-5xl lg:text-[3.75rem]">
          <span className="block text-white">More than memories.</span>
          <span className="block text-[#E7C99D]">A living legacy.</span>
        </h1>
      </Reveal>
      <Reveal delay={240}>
        <p data-testid="hero-subtext" className="mx-auto mt-7 max-w-xl text-[15px] leading-relaxed text-[#B7C3D1] sm:text-base">
          Chronoloop is a private space to preserve your family's photos, videos, voices and stories — beautifully
          organised by AI, and passed down for generations.
        </p>
      </Reveal>
      <Reveal delay={360} className="mt-10">
        <a href="#launching-soon" onClick={goToWaitlist} data-testid="hero-start-journey-button" className="btn-gold">
          Start Your Journey <ArrowRight size={16} strokeWidth={1.5} />
        </a>
      </Reveal>
    </div>
  </section>
);
